var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
var Timmer = function (props) {
    var _a = __read(React.useState({
        min: props.min,
        sec: props.sec,
    }), 2), timer = _a[0], setTimer = _a[1];
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.timerState) {
            setTimer({
                min: props.min,
                sec: props.sec,
            });
        }
    }, [props === null || props === void 0 ? void 0 : props.timerState]);
    React.useEffect(function () {
        var intervalId = setInterval(function () {
            countDown(timer.min, timer.sec, setTimer);
        }, 1000);
        if (timer.min === 0 && timer.sec === 0) {
            clearInterval(intervalId);
            props === null || props === void 0 ? void 0 : props.onTimerClose(true);
        }
        return function () {
            clearInterval(intervalId);
        };
    }, [timer]);
    React.useEffect(function () {
        setTimer({ min: props.min, sec: props.sec });
    }, [props.min, props.sec]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "timer ps-1" },
            React.createElement("span", null,
                "0",
                timer.min),
            React.createElement("span", null, ":"),
            React.createElement("span", null, timer.sec > 9 ? timer.sec : "0" + timer.sec))));
};
export function countDown(min, sec, cb) {
    if (sec === 0 && min !== 0) {
        return cb({ min: min - 1, sec: 59 });
    }
    else if (sec > 0) {
        if (sec > 10) {
            return cb({ min: min, sec: sec - 1 });
        }
        else {
            return cb({ min: min, sec: sec - 1 });
        }
    }
}
export default Timmer;
